module.exports = __webpack_public_path__ + "static/media/whatsapp.31a4087d.svg";